module.exports = __webpack_public_path__ + "img/chapelhill-logo-dark.3158a797.png";